// export const AUTH_URL = "http://localhost:5001";
// export const DISPUTE_URL = "http://localhost:5000";
// export const PRODUCT_URL = "http://localhost:5000";
// export const WALLET_URL = "http://localhost:5000";

export const AUTH_URL = "https://api-iorel-dev.seiraxis.dev/dev/loyalty-auth"
export const DISPUTE_URL = "https://api-iorel-dev.seiraxis.dev/dev/loyalty-dispute"
export const PRODUCT_URL = "https://api-iorel-dev.seiraxis.dev/dev/loyalty-product"
export const WALLET_URL = "https://api-iorel-dev.seiraxis.dev/dev/loyalty-wallet"
